import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const Link = styled.button`
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  color: ${p => p.theme.mediumGray};
  text-decoration: underline;

  &:disabled {
    cursor: default;
  }
`

// Keep the link disabled until summary navigation is implemented.
function SkipToSummaryLink({ onSkip }) {
  return (
    <Link type='button' onClick={onSkip} disabled={!onSkip}>
      Skip to summary
    </Link>
  )
}

SkipToSummaryLink.propTypes = {
  onSkip: PropTypes.func,
}

export default SkipToSummaryLink
